module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon3.caae04ff.svg";